import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AttendanceTakenType } from "../../Types/HeyTraderTypes/Attendances/AttendanceTakenType";
import { getAttendanceTakenList } from "../../Thunks/HeyTraderThunks";

interface AttendanceTakenSliceState {
  loader: boolean; // for refres pages and inital loadings
  attendanceTakenList: AttendanceTakenType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: AttendanceTakenSliceState = {
  loader: false,
  attendanceTakenList: [],
  errorDisplay: '',
}

// set state valu for api response
const attendanceTakenSlice = createSlice({
  name: 'attendanceTakens',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAttendanceTakenList.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getAttendanceTakenList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAttendanceTakenList.fulfilled, (state, action: PayloadAction<AttendanceTakenType[]>) => {
        state.loader = false;
        state.attendanceTakenList = action.payload;
      })
  }
})

export const { } = attendanceTakenSlice.actions
export default attendanceTakenSlice.reducer
